'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgModify(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M11.7462 2.70098C11.9087 2.53824 12 2.31764 12 2.08763C12 1.85762 11.9087 1.63702 11.7462 1.47428L10.5252 0.244681C10.3597 0.0875801 10.1401 0 9.9119 0C9.68365 0 9.46411 0.0875801 9.29854 0.244681L8.50003 1.04609L10.9448 3.49082L11.7462 2.70098ZM0.378909 11.9765L3.42541 10.9754C3.46892 10.9617 3.50858 10.938 3.54114 10.906L10.5252 3.91033L8.08052 1.4656L1.08484 8.44971C1.0529 8.48227 1.0291 8.52192 1.01541 8.56543L0.0143695 11.6119C-0.000236588 11.6565 -0.00377434 11.704 0.00406131 11.7503C0.011897 11.7966 0.0308708 11.8402 0.0593463 11.8775C0.0878219 11.9148 0.124944 11.9447 0.167512 11.9644C0.21008 11.9842 0.256815 11.9933 0.303686 11.9909C0.329244 11.9891 0.354495 11.9843 0.378909 11.9765Z", fill: "currentColor" })));
}

module.exports = SvgModify;
//# sourceMappingURL=Modify.js.map
